import React, { useEffect } from "react";
import * as WidgetUtils from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./DialogResultWidget.module.scss";

export function DialogResultWidget(props) {
  const { ui, data, config, doAction } = props;

  let widgetId = ui.id;
  let buttons = config ? config.Buttons : null;
  let content = data ? JSON.parse(data.content) : null;

  let disabledByUi = ui.readonly;
  let disabledByData = data && data.readonly;
  let disabledToolbar = disabledByUi || disabledByData;

  useEffect(() => {
    //console.log("DialogResultWidget data of " + ui.id + ": ", data);
  }, [data]);

  const onButtonClick = async (actionId) => {
    await doAction(actionId);
  };

  const isControlEnabled = actionId => {
    if (disabledToolbar) return false;
    if (content && content) return content.includes(actionId);
    return false;
  };

  const renderActionButton = (control) => {
    return (
      <Button
        key={control.ActionId}
        className={classes.actionButton}
        text={WidgetUtils.toCleanText(control.DisplayText)}
        hint={control.Tooltip}
        onClick={() => onButtonClick(control.ActionId)}
        disabled={!isControlEnabled(control.ActionId)}
        height="100%"
      />
    );
  };

  return config ? (
    <div className={cn(classes.resultWrapper, "dx-theme-border-color")} id={widgetId}>
      {buttons.map(control => (
        renderActionButton(control)
      ))}
    </div>
  ) : null;
}
